import { render, staticRenderFns } from "./BtnTrial.vue?vue&type=template&id=28af8fb1&"
import script from "./BtnTrial.vue?vue&type=script&setup=true&lang=js&"
export * from "./BtnTrial.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports